<template>
	<div class="tal">
		<div v-if="step === 0">
			<p class="modal_title_m title_s">{{ $t('c2c.buy.title') }}</p>
			<p class="title_s mb_16">{{ $t('c2c.buy.title1') }}</p>
			<p class="title_s mb_8">※{{ $t('c2c.buy.head1') }}</p>
			<p class="info_text body_m mb_16">
				{{ $t('c2c.buy.text1') }}<br />
				{{ $t('c2c.buy.text2') }}<br />
				{{ $t('c2c.buy.text3') }}<br />
				{{ $t('c2c.buy.text4') }}<br />
				{{ $t('c2c.buy.text5') }}
			</p>
			<p class="title_s mb_8">※{{ $t('c2c.buy.head2') }}</p>
			<p class="info_text body_m mb_40">
				{{ $t('c2c.buy.text6') }}<br />
				{{ $t('c2c.buy.text7') }}<br />
				{{ $t('c2c.buy.text8') }}
			</p>
			<button class="button_bg_red button_m" type="button" @click="stepNext">
				{{ $t('button.confirm') }}
			</button>
		</div>

		<form @submit.prevent v-if="step === 1" class="m_buy_asset">
			<div class="d_flex align_items_center modal_title_m" @click="stepBack">
				<span class="LEFTARROW mr_8"></span>
				<p class="title_s">{{ $t('c2c.buy.title') }}</p>
			</div>
			<div class="registration_wrap">
				<div class="mb_16">
					<Extform
						class="border_t_black mt_20 w100 pt_20"
						v-for="extform in dealInfo.extforms"
						:key="extform.seq"
						v-bind="extform"
						v-model="extform.field_values"
						:readonly="true"
					/>
				</div>
				<div class="item_box type1 mb_16">
					<div class="asset_box">
						<span :class="[sourceAsset.code, 'small']"></span>
						<p class="code mr_4">{{ sourceAsset.code }}</p>
						<p class="name">{{ sourceAsset.title }}</p>
					</div>
					<div>
						<div class="value justify_between">
							<span>{{ $t('c2c.buy.head4') }}</span>
							<span class="body_l">{{ dealInfo.source_amount }}</span>
						</div>
						<div class="value justify_between">
							<span>{{ $t('c2c.buy.head5') }}</span>
							<span class="body_l">{{ dealInfo.min_price }}</span>
						</div>
						<div class="value justify_between pb_0">
							<span>{{ $t('c2c.buy.head6') }}</span>
							<span class="body_l">{{ dealInfo.potential_source_amount }}</span>
						</div>
					</div>
				</div>
				<div v-if="sourceAccount" class="mb_16">
					<p class="body_m mb_8">
						{{ $t('c2c.buy.head7') + ' ' + sourceAsset.code }}
					</p>
					<input
						type="text"
						class="tar"
						:value="sourceAccount.balance + ' ' + sourceAsset.code"
						disabled
					/>
				</div>
				<div class="mb_16">
					<p class="body_m mb_8">{{ $t('c2c.buy.head8') }}</p>
					<input type="text" class="tar" placeholder="0" v-model="payAmount" />
				</div>
				<div class="mb_16">
					<p class="body_m mb_8">{{ $t('c2c.buy.head9') }}</p>
					<input
						type="text"
						class="bg tar"
						:value="selectedMarket.fee_rate + ' %'"
						disabled
					/>
					<div class="tar fs_14">
						{{ $t('c2c.buy.head9') }}: {{ calcFeeAmount }}
					</div>
				</div>
				<div class="mb_16">
					<p class="body_m mb_8">
						{{ $t('c2c.buy.head10') }} {{ targetAsset.code }}
						{{ $t('c2c.buy.head11') }}
					</p>
					<input
						type="text"
						class="tar"
						:value="formattingPayAmount"
						disabled
					/>
				</div>
				<p v-if="targetAccount" class="body_m mb_8">
					{{ $t('c2c.buy.head12') }}
				</p>
				<div v-if="targetAccount" class="item_box type1 mb_40">
					<div class="asset_box">
						<span :class="[targetAsset.code, 'small']"></span>
						<p class="code mr_4">{{ targetAsset.code }}</p>
						<p class="name">{{ targetAsset.title }}</p>
					</div>
					<div class="num_unit">
						<p class="num">{{ targetAccount.balance }}</p>
						<p class="unit">{{ targetAsset.code }}</p>
					</div>
				</div>
				<Extform
					class="border_t_black mt_20 pt_20"
					v-for="extform in extforms"
					:key="extform.seq"
					v-bind="extform"
					v-model="extform.field_values"
				/>
				<div class="tac">
					<button
						class="button_bg_red button_m mb_10 normal_submit"
						:disabled="!canBuy"
						@click="buyHandler"
					>
						{{ $t('button.application') }}
					</button>
					<button class="button_bg_red button_m mb_10 disabled_submit" disabled>
						{{ $t('button.application') }}
					</button>
				</div>
			</div>
		</form>
	</div>
	<ModalMessageM v-if="messageModal" @closeModal="closeMessageModal">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'information'">
			<button class="button_bg_red button_m" @click="createPrivateApplication">
				{{ $t('button.confirm') }}
			</button>
			<a @click="messageModal = false" class="a_cancel_btn mt_15">{{
				$t('button.cancel')
			}}</a>
		</div>
		<div v-if="messageModalMode === 'success'">
			<button class="button_bg_red button_m" @click="toActivity">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>
<script>
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import { mapGetters } from 'vuex';
import {
	createPrivateApplication,
	fetchPrivateDeal,
	fetchPrivateMarkets,
	fetchPrivateMarketForms,
} from '@/api/market';
import { commonError } from '@/common/dialog';
import Extform from '@/components/Extform/Extform';

export default {
	name: 'C2cBuy.m',
	emits: ['close', 'closeParentModal'],
	components: { ModalMessageM, Extform },
	props: {
		dealSeq: {
			type: Number,
		},
	},
	data() {
		return {
			step: 0,
			markets: [],
			extforms: [],
			dealInfo: {},
			payAmount: null,
			messageModalMode: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
		};
	},
	computed: {
		...mapGetters('assets', ['assets', 'registedAssets']),
		...mapGetters('account', ['accounts']),
		selectedMarket() {
			return this.markets.find(item => {
				return item.seq === this.dealInfo.market_seq;
			});
		},
		sourceAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedMarket.source_asset_seq;
			});
		},
		targetAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedMarket.target_asset_seq;
			});
		},
		sourceAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedMarket.source_asset_seq;
			});
		},
		targetAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedMarket.target_asset_seq;
			});
		},
		calcFeeAmount() {
			return this.formattingPayAmount * (this.selectedMarket.fee_rate / 100);
		},
		formattingPayAmount() {
			if (!this.payAmount) return null;
			const payAmount =
				parseFloat(this.payAmount) * parseFloat(this.dealInfo.min_price);
			return payAmount.toFixed(this.targetAsset.decimal_point);
		},
		canBuy() {
			return !!this.payAmount;
		},
	},
	watch: {
		step(value) {
			if (value === 1) this.payAmount = null;
		},
		payAmount(value) {
			if (!value) return;
			this.payAmount = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
		},
	},
	methods: {
		closeMessageModal() {
			if (this.messageModalMode === 'success') {
				// debugger;
				// this.$emit('closeParentModal');
				this.initForm();
				window.scrollTo(0, 0);
			} else {
				// debugger;
				this.messageModal = false;
			}
		},
		stepBack() {
			this.step--;
		},
		stepNext() {
			// 확인 버튼 클릭시 스크롤 상단 이동
			document.querySelector('.modal_scrollable').scrollTo(0, 0);
			this.step++;
		},
		init() {
			Promise.all([this.loadPrivateMarkets(), this.loadDealInfo()]).then(() =>
				this.loadExtforms(),
			);
		},
		async loadPrivateMarkets() {
			const { data } = await fetchPrivateMarkets().catch(commonError);
			this.markets = data;
		},
		async loadDealInfo() {
			const { deal_info, field_values, forms } = await fetchPrivateDeal(
				this.dealSeq,
			).catch(commonError);
			const extforms = forms.map(form => ({
				...form,
				fields: [],
				field_values: [],
			}));
			field_values.forEach(item => {
				const form = extforms.find(form => form.seq === item.form_seq);
				form.fields.push(item);
				form.field_values.push(item);
			});
			deal_info.extforms = extforms;
			this.dealInfo = deal_info;
		},
		async loadExtforms() {
			const { forms } = await fetchPrivateMarketForms(
				this.dealInfo.market_seq,
				'MARKET_PRIVATE_APPLICATION',
			).catch(commonError);
			this.extforms = forms.map(item => ({ ...item, field_values: [] }));
		},
		buyHandler() {
			this.modalIcon = 'information';
			this.messageModalMode = 'information';
			this.modalStatusMessage = this.$t('modal.message.set_buy');
			this.messageModal = true;
		},
		async createPrivateApplication() {
			const params = {
				deal_seq: this.dealSeq,
				account_seq: this.sourceAccount?.seq,
				target_account_seq: this.targetAccount?.seq,
				source_amount: this.payAmount,
				price: this.dealInfo.min_price,
				field_values: [].concat(
					...this.extforms.map(item => item.field_values),
				),
			};
			await createPrivateApplication(params)
				.then(() => {
					this.$store.dispatch('account/getAccounts');
					this.modalIcon = 'success';
					this.messageModalMode = 'success';
					this.modalStatusMessage = this.$t('modal.message.registered');
				})
				.catch(e => {
					this.messageModal = false;
					commonError(e);
				});
		},
		initForm() {
			this.messageModal = false;
			this.payAmount = '';
			this.selectedTargetSeq = '';
		},
		toActivity() {
			this.$router.push({
				name: 'activity-c2c',
			});
		},
	},
	mounted() {
		this.init();
	},
};
</script>

<style scoped>
.m_buy_asset:invalid .normal_submit {
	display: none;
}
.m_buy_asset:valid .disabled_submit {
	display: none;
}
</style>
